/**
 * Добавляет параметр mortgage_type к URL с учетом существующих query параметров и якорей
 */
export function addMortgageTypeToUrl(url: string, mortgageType: string | undefined): string {
  if (!mortgageType) {
    return url;
  }

  // Разделяем URL на части: базовый URL, query параметры и якорь
  const hashIndex = url.indexOf('#');
  const queryIndex = url.indexOf('?');

  // Определяем часть URL для обработки (до якоря, если он есть)
  const urlEnd = hashIndex !== -1 ? hashIndex : url.length;
  const urlWithoutHash = url.substring(0, urlEnd);
  const hash = hashIndex !== -1 ? url.substring(hashIndex) : '';

  let baseUrl: string;
  let existingQuery = '';

  // Обрабатываем query параметры (проверяем, что они находятся в правильной части URL)
  if (queryIndex !== -1 && queryIndex < urlEnd) {
    // Query параметры есть и они находятся до якоря
    baseUrl = urlWithoutHash.substring(0, queryIndex);
    existingQuery = urlWithoutHash.substring(queryIndex + 1);
  } else {
    // Нет query параметров
    baseUrl = urlWithoutHash;
  }

  // Формируем итоговый query string
  // Если уже есть query параметры, добавляем через &, иначе через ?
  const queryString = existingQuery
    ? `?${existingQuery}&mortgage_type=${mortgageType}`
    : `?mortgage_type=${mortgageType}`;

  return `${baseUrl}${queryString}${hash}`;
}
